// src/modals/CautionMessagePreview.jsx — APERÇU EN DIRECT du message #21
// « caution restituée » (mécanique B, ADR-272).
//
// EXIGENCE FORTE Dimitri : « Rien ne part sans que Dimitri ait vu le rendu
// final. » Ce composant est monté À CÔTÉ du champ « Motif du prélèvement » dans
// chaque modale caution (Capture / Refund / Release) de _PaiementsTabBody.jsx.
// Il rend le #21 FINAL (objet + corps) tel que le voyageur le recevra, mis à
// jour EN TEMPS RÉEL à chaque frappe (useMemo, 0 réseau).
//
// Moteur = src/lib/caution-restitution-preview.js (2 passes, parité serveur).
// Rendu = carte « device » (entête navy + corps en paragraphes), style aligné
// sur la PreviewCard de DirectMessagesView.
//
// ⚠️ Le corps affiché est le VERBATIM DE DÉMO (#21 non encore posé — pose = B7).
// Aucun envoi n'est déclenché par ce composant : il est purement cosmétique.

import { useMemo } from "react"
import { DS } from "../lib/ui"
import {
  buildCautionPreviewVars,
  renderCautionPreview,
  CAUTION_RESTITUEE_DEMO_SUBJECT,
  CAUTION_RESTITUEE_DEMO_BODY,
} from "../lib/caution-restitution-preview"

export default function CautionMessagePreview({
  cautionAmount,
  montantPreleve,
  nbNuits,
  motif,
  guestFirstName,
  logementName,
  // Corps/objet posés (B7) — optionnels ; à défaut, verbatim de démo.
  bodyTemplate,
  subjectTemplate,
}) {
  const { subject, body } = useMemo(() => {
    const vars = buildCautionPreviewVars({
      cautionAmount,
      montantPreleve,
      nbNuits,
      motif,
      guestFirstName,
      logementName,
    })
    return {
      subject: renderCautionPreview(subjectTemplate || CAUTION_RESTITUEE_DEMO_SUBJECT, vars),
      body: renderCautionPreview(bodyTemplate || CAUTION_RESTITUEE_DEMO_BODY, vars),
    }
  }, [
    cautionAmount,
    montantPreleve,
    nbNuits,
    motif,
    guestFirstName,
    logementName,
    bodyTemplate,
    subjectTemplate,
  ])

  const lines = body.split("\n")

  return (
    <div data-testid="caution-msg-preview" style={{ marginBottom: 14 }}>
      <div
        style={{
          fontSize: 11,
          fontWeight: 700,
          color: DS.navy,
          textTransform: "uppercase",
          letterSpacing: 0.5,
          marginBottom: 6,
        }}
      >
        Aperçu du message au voyageur (en direct)
      </div>
      <div
        style={{
          borderRadius: 14,
          overflow: "hidden",
          border: "1px solid rgba(33,83,135,.15)",
          boxShadow: "0 10px 26px -14px rgba(20,51,80,.4)",
        }}
      >
        <div
          style={{
            background: `linear-gradient(160deg, ${DS.marine} 0%, ${DS.marineDark} 100%)`,
            color: "#fff",
            padding: "14px 16px",
          }}
        >
          <div
            style={{
              fontSize: 10,
              letterSpacing: 1,
              color: "#a9cbec",
              textTransform: "uppercase",
            }}
          >
            Objet
          </div>
          <div
            data-testid="caution-msg-preview-subject"
            style={{ fontWeight: 700, fontSize: 14, marginTop: 4, lineHeight: 1.3 }}
          >
            {subject || "(objet)"}
          </div>
        </div>
        <div
          data-testid="caution-msg-preview-body"
          style={{
            background: "#fff",
            padding: "14px 16px",
            fontSize: 12.5,
            color: "#33414f",
            lineHeight: 1.6,
          }}
        >
          {lines.map((line, i) =>
            line.trim() === "" ? (
              <div key={i} style={{ height: 8 }} />
            ) : (
              <p key={i} style={{ margin: "0 0 8px" }}>
                {line}
              </p>
            ),
          )}
        </div>
      </div>
    </div>
  )
}
